import { C, StatusDot } from "@coremonit/design-system";

export function HealthScoreRing({ score, grade, size = 28 }: { score: number; grade: string; size?: number }) {
  const color = score >= 85 ? C.green : score >= 65 ? C.amber : C.red;
  const pct = score / 100;
  const r = (size - 4) / 2;
  const circ = 2 * Math.PI * r;
  return (
    <svg width={size} height={size} style={{ flexShrink: 0 }}>
      <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke={C.border} strokeWidth={3} />
      <circle
        cx={size / 2} cy={size / 2} r={r} fill="none" stroke={color} strokeWidth={3}
        strokeDasharray={`${circ * pct} ${circ}`}
        strokeLinecap="round"
        transform={`rotate(-90 ${size / 2} ${size / 2})`}
      />
      <text x="50%" y="54%" textAnchor="middle" fill={color} fontSize={size * 0.32} fontWeight={700}>{grade}</text>
    </svg>
  );
}

export function HealthDot({ status }: { status: string }) {
  const mapped = status === "healthy" || status === "running" ? "healthy"
    : status === "warning" || status === "pending" ? "warning"
    : status === "critical" || status === "crashloop" ? "critical" : "unknown";
  return <StatusDot status={mapped as "healthy" | "warning" | "critical" | "unknown"} pulse={mapped !== "healthy"} />;
}
